
import React, { useEffect, useState } from "react";
import { db, collection, getDocs, limit, query } from "../../../firebaseClient";

const TARGET_COLLECTIONS = [
    "legal_contracts",
    "legal_cases",
    "legal_disputes",
    "approval_requests",
    "approvalFlows",
    "brand_assets",
    "legal_lawyers",
    "legal_work_logs",
    "notifications"
];

export const DataHealthPanel: React.FC = () => {
    const [counts, setCounts] = useState<Record<string, number | string>>({});
    const [loading, setLoading] = useState(false);

    const checkHealth = async () => {
        setLoading(true);
        const results: Record<string, any> = {};
        
        for (const colName of TARGET_COLLECTIONS) {
            try {
                // Try to get at least one doc to verify existence/permission
                // Not using getCountFromServer for broad compatibility, just sampling
                const q = query(collection(db, colName), limit(5));
                const snap = await getDocs(q);
                results[colName] = snap.empty ? 0 : `${snap.size}+ (Exists)`;
            } catch (e: any) {
                results[colName] = `Error: ${e.code || e.message}`;
            }
        }
        setCounts(results);
        setLoading(false);
    };

    useEffect(() => {
        checkHealth();
    }, []);

    return (
        <div className="section" style={{ border: '1px solid #a78bfa' }}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 12}}>
                <h3 className="h1" style={{color: '#a78bfa', margin:0}}>C. 資料源健康診斷 (Data Health)</h3>
                <button className="smallbtn" onClick={checkHealth} disabled={loading}>
                    {loading ? "Checking..." : "Refresh Check"}
                </button>
            </div>
            
            <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap: 10}}>
                {TARGET_COLLECTIONS.map(col => {
                    const val = counts[col];
                    const isError = typeof val === 'string' && val.startsWith('Error');
                    const isEmpty = val === 0;
                    
                    let color = 'var(--ok)';
                    if (isError) color = 'var(--danger)';
                    else if (isEmpty) color = '#fbbf24';

                    return (
                        <div key={col} style={{background: '#222', padding: 10, borderRadius: 6, borderLeft: `3px solid ${color}`}}>
                            <div style={{fontSize: 11, color: '#888', marginBottom: 4}}>{col}</div>
                            <div style={{fontWeight: 'bold', color: color, fontSize: 13}}>
                                {val === undefined ? '...' : val}
                            </div>
                        </div>
                    );
                })}
            </div>
            
            <div style={{marginTop: 12, fontSize: 12, color: '#aaa', lineHeight: 1.5}}>
                <b>診斷說明：</b><br/>
                • <b>Error</b>: 通常是權限不足 (Firestore Rules) 或連線失敗。<br/>
                • <b>0</b>: 連線成功但無資料，或被 Query 篩選濾掉 (如果是空的 DB)。<br/>
                • <b>5+ (Exists)</b>: 資料存在且可讀取。若頁面仍空白，請檢查前端 Filter 邏輯。
            </div>
        </div>
    );
};

// touch: data-visibility-debug
